export const OPEN_CHAT_SIDE_BAR = 'state.ui.chat-details.OPEN_CHAT_SIDE_BAR';
export const CLOSE_CHAT_SIDE_BAR = 'state.ui.chat-details.CLOSE_CHAT_SIDE_BAR';

export interface OpenChatSideBar {
	type: typeof OPEN_CHAT_SIDE_BAR;
}

export interface CloseChatSideBar {
	type: typeof CLOSE_CHAT_SIDE_BAR;
}

export const openChatSideBar = (): OpenChatSideBar => ({
	type: OPEN_CHAT_SIDE_BAR,
});

export const closeChatSideBar = (): CloseChatSideBar => ({
	type: CLOSE_CHAT_SIDE_BAR,
});
